<template>
  <div class="sc-card">
    <h4 class="sc-card-title mt-4">Qual o valor das suas consultas?</h4>
    <div class="sc-card-body">
      <form>
        <div class="custom-form-control">
          <input
            class="form-control"
            v-mask="['R$ ##', 'R$ ###', 'R$ ####']"
            v-model="price_cents"
          />
        </div>
      </form>
      <Button
        id="activeAccountBtn"
        variant="primary"
        size="lg"
        block
        :disabled="canActiveAccount"
        @click.native="sendCreateAccount"
      >
        Confirmar
      </Button>
    </div>
  </div>
</template>

<script>
import Button from '../components/Button';
export default {
  name: "WireCardAccount",
  components: {
    Button
  },
  data() {
    return {
      price_cents: '',
    };
  },
  methods: {
    sendCreateAccount() {
      this.$store.dispatch("doctor/activateWireCardAccount", this.price_cents).then(() => {
        this.accountActivated = true;
        this.$emit("accountActivated");
      });
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.user.currentUser;
    },
    wireCardAccountActivated() {
      return !!this.$store.state.user.currentUser.account.id;
    },
    canActivateWireCardAccount() {
      return !!(this.currentUser.address.id && this.currentUser.birthday);
    },
    canActiveAccount() {
      return this.price_cents.length < 4;
    }
  }
};
</script>

<style></style>
